<template>
    <div class="bottom desktop">
        <div class="content-max-width flex">
            <img v-show="headerIsSticky" src="/images/logo-mark.svg" alt="Habit Health" class="sticky-logo">
            <div class="wrap">
                <div class="flex">
                    <div
                        class="parent flex"
                        v-for="link in links"
                        :key="link.id"
                        @mouseover="showingMenu = link.id"
                        @mouseleave="showingMenu = null"
                    >
                        <!-- needs to be a link :href="link.url" -->
                        <a class="parent-link">
                            <h6 class="flex">
                                {{ link.title }}
                                <span v-if="link.type === 'Dropdown'"
                                    class="icon icon-angle-down"
                                ></span>
                            </h6>
                            <span>{{ link.alt_text }}</span>
                        </a>

                        <div v-if="showingMenu == link.id && link.type === 'Dropdown'" class="megamenu">
                            <div class="content-max-width">
                                <p class="lead" v-if="link.heading">{{link.heading}}</p>

                                <slick :ref="`menu-slick-${link.id}`" class="menu-slider"
                                       :class="`menu-${link.id}`"
                                       :options="{
                    arrows:true, slidesToScroll:1, slidesToShow:4, infinite:false,
                    responsive: [
                      { breakpoint: 1350, settings: { arrows:false } },
                      { breakpoint: 1024, settings: { slidesToShow:4 } },
                      { breakpoint: 850, settings: { slidesToShow:3 } },
                      { breakpoint: 350, settings: { slidesToShow:2 } }
                    ]
                  }"
                                >
                                    <div class="link-group" v-for="childLink in link.children" :key="childLink.id">
                                        <a
                                            :href="childLink.url"
                                            style="display: block; padding:0;"
                                        >
                                            <h6>{{ childLink.title }}</h6>
                                            <span>{{ childLink.alt_text }}</span>
                                        </a>
                                        <!--
                                      <a :href="childLink.url" style="display: block; padding:0;">
                                        <img :src="childLink.image" alt="" class="group-img lazyload">
                                      </a>
                                       -->
                                        <div class="childLinks" v-if="childLink.children.length > 0">
                                            <a
                                                v-for="grandChildLink in childLink.children"
                                                :key="grandChildLink.id"
                                                :href="grandChildLink.url"
                                                :target="grandChildLink.is_external ? 'blank' : null"
                                            >{{ grandChildLink.title }}</a>

                                            <a v-if="childLink.view_all.length > 0" :href="childLink.url" class="all">{{childLink.view_all}}</a>
                                        </div>
                                    </div>
                                </slick>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
    components: {
        Slick,
    },

    props: {
        links: {
            type: Array,
            required: true,
        },
    },

    data () {
        return {
            showingMenu: null,
            headerIsSticky: false,
        }
    },

    mounted () {
        // listen to scrolls
        document.addEventListener('scroll', () => {
            const position = window.scrollY
            let ticking = false

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.headerIsSticky = position >= 147
                    ticking = false
                });

                ticking = true
            }
        });
    },
}
</script>

<style scoped>
.megamenu {
    box-shadow: 0 4px 5px 0 rgba(101,119,129,0.4);
}
.megamenu p.lead {
    max-width: 570px;
    margin: 0 0 40px;

    font-size: 15px;
    letter-spacing: 0;
    line-height: 24px;
    color: #657781;
    white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/SubHeader.vue